import Vue from 'vue';
import * as types from '../mutation-types';
import AttachmentAPI from '../../api/contacts';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isError: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
};
// SET_CONTACT_LABELS_UI_FLAG  -=> SET_ATTACHMENT_UI_FLAG
// SET_CONTACT_LABELS => SET_ATTACHMENT
export const actions = {
  get: async ({ commit }, contactId) => {
    commit(types.default.SET_ATTACHMENT_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await AttachmentAPI.getAttachments(contactId);
      commit(types.default.SET_ATTACHMENT, {
        id: contactId,
        data: response.data.payload,
      });
      commit(types.default.SET_ATTACHMENT_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_ATTACHMENT_UI_FLAG, {
        isFetching: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_ATTACHMENT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_ATTACHMENT]: ($state, { id, data }) => {
    Vue.set($state.records, id, data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};